var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Content',{staticClass:"col-span-full",attrs:{"title":_vm.$route.name}},[_c('RoutingListForm',{on:{"path":function($event){_vm.path = $event},"tableData":function($event){_vm.detailList = $event},"realtime":function($event){_vm.realtime = $event},"anomaly":function($event){_vm.anomalyPoints = $event},"vehicleId":function($event){_vm.vehicleId = $event}}}),_c('div',{staticClass:"flex flex-col gap-4"},[_c('stopsTable',{staticClass:"mt-8",attrs:{"tableData":_vm.detailList.stops}}),_c('tripsTable',{attrs:{"tableData":_vm.detailList.trips,"vehicleId":_vm.vehicleId},on:{"path":function($event){_vm.path = $event},"realtime":function($event){_vm.realtime = $event}}})],1),_c('RoutingMap',{directives:[{name:"show",rawName:"v-show",value:(_vm.path != null),expression:"path != null"}],attrs:{"tripDetail":_vm.path,"realtime":_vm.realtime}}),(_vm.path != null)?_c('Content',{staticClass:"col-span-full mt-8",attrs:{"childClass":"border-whitee","title":"SPEED_GRAPH","showBreadcrumb":false,"showAdd":false}},[_c('VueApexCharts',{attrs:{"type":"line","height":"350","options":{
        chartOptions: _vm.chartOptions,
        labels: _vm.date,
        annotations: {
          yaxis: [
            // {
            //   y: path.speeds.max_speed,
            //   borderColor: '#b30000',
            //   label: {
            //     borderColor: '#b30000',
            //     textAnchor: 'start',
            //     style: {
            //       color: '#fff',
            //       background: '#b30000',
            //     },
            //     text: `${$t('MAX_SPEED')}: ${path.speeds.max_speed}km/h`,
            //   },
            // },
            // {
            //   y: path.speeds.avg_speed,
            //   borderColor: '#d0aa00',
            //   label: {
            //     borderColor: '#d0aa00',
            //     textAnchor: 'start',
            //     style: {
            //       color: '#fff',
            //       background: '#d0aa00',
            //     },
            //     text: `${$t('AVG_SPEED')}: ${path.speeds.avg_speed}km/h`,
            //   },
            // },
          ],
        },
        points: [
          {
            x: new Date('01 Dec 2017').getTime(),
            y: _vm.path.max_speed,
            marker: {
              size: 8,
              fillColor: '#fff',
              strokeColor: 'red',
              radius: 2,
              cssClass: 'apexcharts-custom-class',
            },
            label: {
              borderColor: '#FF4560',
              offsetY: 0,
              style: {
                color: '#fff',
                background: '#FF4560',
              },

              text: 'Point Annotation',
            },
          } ],
      },"series":_vm.speeds}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }